import React from "react";

export function Eyebrow({ children, index, className = "" }) {
  return (
    <div className={"flex items-center gap-3 " + className}>
      {index && (
        <span className="font-mono text-[0.65rem] tracking-[0.25em] uppercase text-[var(--ink)]/60">
          {index}
        </span>
      )}
      <span className="font-mono text-[0.7rem] tracking-[0.25em] uppercase text-[var(--ochre)]">
        {children}
      </span>
    </div>
  );
}

export function SectionHeading({ children, className = "" }) {
  return (
    <h2
      className={
        "font-display text-3xl md:text-5xl leading-[1.02] tracking-tight text-[var(--ink)] " +
        className
      }
    >
      {children}
    </h2>
  );
}

export function SectionBody({ children, className = "" }) {
  return (
    <p className={"text-base md:text-lg leading-relaxed text-[var(--muted)] " + className}>
      {children}
    </p>
  );
}

export function Section({ children, index, eyebrow, className = "", id }) {
  return (
    <section id={id} className={"border-t border-[var(--rule)] " + className}>
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-12 py-20 md:py-28">
        {(eyebrow || index) && (
          <Eyebrow index={index} className="mb-10">
            {eyebrow}
          </Eyebrow>
        )}
        {children}
      </div>
    </section>
  );
}
